import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Observable } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TelemedicineService } from '../../services/telemedicine.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
// import  {  }

declare var jQuery: any;

@Component({
    selector: 'kx-telemedicine-modal',
    templateUrl: './telemedicine-modal.component.html',
    styleUrls: ['./telemedicine-modal.component.scss'],
    standalone: false
})
export class TelemedicineModalComponent implements OnInit {
  payload: any;
  origin: any;
  message: any;
  call: any;
  @Input() data: any;
  title: any;

  constructor(
    private authservice: AuthenticationService,
    private baseService: BaseService,
    private bsModal: BsModalRef,
    private ts: TelemedicineService,
    private dec: ChangeDetectorRef,
    private translateService: TranslateService
    // private 
  ) { }

  ngOnInit() {
    this.translateService.translate("message.please_join_video_call").subscribe(x => {
      if (x) {
        this.message = x;
      }
    });
    this.origin = location.origin;
    let data = this['data'];
    let notificationbody = this.data.notification.body.split(",")
    this.data['userId'] =  notificationbody[0].replace(/\s+/g, '');
    this.data['user_name'] =  notificationbody[1];
    this.data['order_id'] =  notificationbody[2];
    this.data['channel_id'] =  notificationbody[3].replace(/\s+/g, '');
    this.title = `Video call request from  ${this.data.user_name}`
    setTimeout(function () {
      const that = this
      that.call = document.getElementById("play_ringtone");
      if (that.call)
        that.call.pause();
      if (that.bsModal)
        that.bsModal.hide(1);
    }, 10000)
  }

  ngAfterViewInit() {
    this.call = document.getElementById("play_ringtone");
    this.call.play();
  }

  hasCall() {
    this.call = document.getElementById("play_ringtone");
    this.call.pause();
    this.bsModal.hide()
    console.log("this.data", this.data);
    this.ts.initCallData(this.data.userId, this.data.user_name, this.data.channel_id)
    this.dec.detectChanges();
  }

  notAttendCall() {
    this.call = document.getElementById("play_ringtone");
    this.call.pause();
    // this.sendNotification(JSON.parse(this.data.data.body).senderId, "videoCallEnd", "", JSON.parse(this.data.data.body).channelId);
    this.bsModal.hide()
  }

  sendNotification(destinationUserId: any, action: string, role: string, consultID: any): Observable<any> {
    var hasPayload = { webAction: "videoCallStart", extras: "", androidAction: "", title: "Video Call Request", message: this.message, senderId: this.authservice.getCurrentUser()['user_id'], channelId: consultID }
    var json = {
      destination_user_id: destinationUserId,
      src_user_id: this.authservice.getCurrentUser()['user_id'],
      payload: JSON.stringify(hasPayload),
      readUnreadStatus: false,
      role: role,
      action: action
    }
    return this.baseService.action(json, 'add', 'notification', 'push_notification')
  }

}
